module.exports = __webpack_public_path__ + "img/3-4.b8f17da2.svg";